module.exports = __webpack_public_path__ + "static/img/img-sjwj.6698722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-sjwj.png
// module id = 454
// module chunks = 2